import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import ViewSubscriberResults from '../../components/quiz/view-subscriber-results.component';

const QuizSubscriberResultsView = () => {
  const { id, subscriberId } = useParams();
  const pageTitle = PAGE_TITLE_LIST.QUIZ_SUBSCRIBER_RESULTS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ViewSubscriberResults quizId={id} subId={subscriberId} />
    </AppLayout>
  );
};

export default QuizSubscriberResultsView;
